import DashboardLayout from "../../components/layout/DashboardLayout";
import AccountSummary from "../../components/new-dashboard/AccountSummary";
import usePageTitle from "../../hooks/usePageTitle";
import BotPerformance from "../../components/new-dashboard/BotPerformance";
import TopCommunityBots from "../../components/new-dashboard/TopCommunityBots";
import MyTasks from "../../components/new-dashboard/MyTasks";
import LatestSignals from "../../components/new-dashboard/LatestSignals";
import MarketOverview from "../../components/new-dashboard/MarketOverview";
import { useParams } from "react-router-dom";
import PdfReport from "../../components/bot/PdfReport";

function NewDashboard() {
  usePageTitle("Dashboard");
  const { section } = useParams();

  return (
    <>
      <DashboardLayout>
        {!section && (
          <>
            <AccountSummary />
            <BotPerformance />
            <LatestSignals />
            <TopCommunityBots />
            <MyTasks />
            <MarketOverview />
          </>
        )}
        {section === "bot-report" && <PdfReport backPath="/dashboard" />}
      </DashboardLayout>
    </>
  );
}

export default NewDashboard;
